import axios from 'axios';
import { getConfig } from '../config';
import { Payment } from '../types/Payment';
import { dataService } from './core/dataService';

export const paymentService = {
  get baseService() {
    return dataService<Payment>('payments');
  },

  updatePaymentStatus: async (id: string, status: string, token?: string): Promise<Payment | null> => {
    const { apiUrl } = getConfig();
    try {
      const response = await axios.patch(
        `${apiUrl}/payments/${id}/status`,
        { status },
        {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        }
      );
      return response.data?.data || response.data || null;
    } catch (error) {
      console.error('[paymentService] updatePaymentStatus error:', error);
      return null;
    }
  },
};